import { toSentenceCase } from "./string";

export const getCloudEnvironment = () => {
  const { host } = window.location;
  const site = (host || "").replace(/\.visiblethread\.com/, "");

  if (!site || site.includes("localhost")) {
    return "development";
  }

  return site
    .split(/[._-]/)
    .map((part, index) => {
      if (index === 0) {
        return part.toLowerCase();
      }
      return toSentenceCase(part);
    })
    .join("");
};
